import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";
import ReactGA from "react-ga";

ReactGA.pageview(window.location.pathname + window.location.search);

const Conservation = () => {
  return (
    <div>
      <Helmet>
        <title>SAWA | Conservation</title>
        <meta name="description" content="" />
        <link rel="canonical" href="/conservation" />
      </Helmet>
      <NavBar />
      <section className="relative h-[80vh] flex flex-col justify-center items-center text-white">
        <img
          src="https://res.cloudinary.com/duchitv8b/image/upload/v1727706275/mya2w1miopqxevpymjmb.webp"
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-70 z-10"></div>
        <div
          className="relative z-20 text-center px-4 sm:px-6 lg:px-8"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold mb-4">
            TUZIVUGIRE
          </h1>
          <p className="max-w-lg mt-10 sm:max-w-xl md:max-w-2xl lg:max-w-4xl font-light mx-auto text-lg sm:text-xl md:text-2xl">
            /too-zee-vu-gee-lei/
          </p>
        </div>
        <div className="absolute top-0 left-0 w-full h-full border-l-[1px] border-b-[3px] border-white z-30"></div>
      </section>

      <div className="flex flex-col md:flex-row items-start justify-between p-4 md:p-16 py-20 text-center md:text-left md:py-28 bg-inkawe text-white">
        <div className="relative w-full md:w-1/2 text-4xl md:text-5xl font-bold leading-tight mb-4 md:mb-0 md:mr-8 h-auto md:h-screen text-center md:text-left">
          <h2 className="md:sticky top-0">TUZIVUGIRE PROGRAM</h2>
        </div>
        <div className="w-full md:w-1/2 text-base leading-relaxed">
          <p
            className="text-lg md:text-2xl md:mt-0 mt-10"
            data-aos="fade-in"
            data-aos-duration="600"
          >
            At SAWA, we believe art has the extraordinary ability to inspire,
            educate and ignite change. That's why we created TUZIVUGIRE - a
            dynamic program dedicated to advocating for nature through the power
            of art. <br /> <br />
            We’re nurturing the next generation of conservationists by
            partnering with schools to establish art workshops and clubs.Through
            these initiatives, students develop a deep appreciation for nature
            while honing their artistic abilities.
            <br /> <br />
            To create a more significant impact, we're collaborating with
            leading conservation organizations. By merging art and
            science, we’re developing innovative projects that safeguard our
            planet.
            <br /> <br />
            We envision a Rwanda adorned with vibrant public murals that carry
            powerful conservation messages. These artworks will spark
            conversations, inspire action, and foster a deeper connection with
            nature within our communities.
            <br />
            <br />
            TUZIVUGIRE is more than a program; it's a movement. We invite
            artists, educators, and community members to join us in using art as
            a force for good. A portion of the proceeds from artwork sales
            directly supports TUZIVUGIRE, ensuring its continued growth and
            impact.
            <br />
            <br />
            Daily updates on our projects, events, and the inspiring work of our
            artists are shared across our social media platforms.
          </p>
        </div>
      </div>
      <section>
        <div className="relative h-screen flex items-center justify-center text-center">
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1000/rnfaeljiyjzjds1h0ihp.webp"
            alt="Artist"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-70"></div>
          <div className="relative z-10 flex flex-col items-center max-w-full text-gray-50 p-4 md:p-8">
            <h2
              className="mb-4 text-4xl md:text-6xl font-bold"
              data-aos="fade-out"
              data-aos-duration="1000"
            >
              Book Your Visit Today
            </h2>
            <p
              className="mb-4 text-lg md:text-2xl demfont px-0 md:px-16 w-4/5 mx-auto mt-3 demline"
              data-aos="fade-out"
              data-aos-duration="1000"
            >
              SAWA requests that visitors book their visits in advance to
              support their artists and ensure a positive experience for
              everyone. Booking fees help artists focus on their creative
              pursuits without worrying about immediate sales.
            </p>
            <button
              className="bg-secondary text-white font-bold font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center"
              data-aos="fade-up"
              data-aos-duration="400"
            >
              Book Now
              {/* <span className="ml-2 mt-1 font-bold">{">"}</span> */}
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Conservation;
